import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
export const defaultFeatureFlags = {
  hideCategoriesFromAppTiles: false,
  hideInstallDownloadCountsEnabled: false,
  showAppRequestPlaceholder: false,
  showQuickLinksToPartners: false,
  sortingLogicForCategoryFilter: 'default',
  freeCheckbox: false,
  displayPricingCalculator: false,
  enableBugBountyProgram: false,
  enableRequestAppCtaCopyChange: false,
  enableTrialExpiryBanner: false,
  enableCloudFortifiedAppsDiscovery: false,
  showCloudMigrationAppListing: false,
  showMessageForFreeAppSupportForSandbox: false,
  managePartnerSpaTabs: ['Promotions'],
  enableChangesForH2HForMpv: false,
  'confluence.frontend.invite-from-github.cohort': 'not-enrolled',
  enableWebpImage: false
};
const FeatureFlags = /*#__PURE__*/React.createContext(defaultFeatureFlags);
export function useFeatureFlags() {
  return useContext(FeatureFlags);
}
export function withFeatureFlags(WrappedComponent) {
  return function FeatureFlagsHOC(props) {
    return /*#__PURE__*/React.createElement(FeatureFlags.Consumer, null, featureFlags => {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, featureFlags, props));
    });
  };
}
export default FeatureFlags;